import { render, staticRenderFns } from "./MeasurementBDGL.vue?vue&type=template&id=b0fbd07a&scoped=true&"
import script from "./MeasurementBDGL.vue?vue&type=script&lang=ts&"
export * from "./MeasurementBDGL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fbd07a",
  null
  
)

export default component.exports